import React from "react";

export const PolarisStar = ({ className = "w-8 h-8", color = "#ff5c49" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <path
      d="M24 1 L27.5 18 C28 20.5 29.5 22 32 20.5 L41 15 L35.5 24 C34 26.5 34 27.5 36.5 29 L47 32.5 L30 27.5 C27.5 27 26 28.5 27.5 31 L33 41 L25 34.5 C23 33 22.5 33.5 21 35.5 L15 44 L19.5 28 C20 25.5 19 24.5 16.5 25 L1 27 L18 22.5 C20.5 22 21 20.5 20.5 18 Z"
      fill={color}
    />
    <circle cx="24" cy="24" r="3.4" fill="#2b2a33" />
  </svg>
);
